import React, { Component } from "react";
import gql from "graphql-tag";

import { Mutation, Query } from "react-apollo";
import { connect } from "react-redux";
import { Box } from "reflexbox";

import { Dropdown } from "office-ui-fabric-react/lib/Dropdown";
import { Checkbox } from "office-ui-fabric-react/lib/Checkbox";
import { Callout } from "office-ui-fabric-react/lib/Callout";

import { dismissShipmentStatus } from "../../actions/ui_actions";

class ShipmentStatusCallout extends Component {
  render() {
    const { shipment } = this.props;
    const id = shipment.id;
    return (
      <div>
        {this.props.visible && (
          <Query query={GET_SHIPMENT_STATUS} variables={{ id }} skip={!id}>
            {({ loading, error, data }) => {
              if (loading) return "Loading...";
              if (error) return `Error! ${error.message}`;
              const status =
                data && data.shipmentById && data.shipmentById.status
                  ? JSON.parse(data.shipmentById.status)
                  : "";

              return (
                <div>
                  <Callout
                    gapSpace={0}
                    target={document.getElementById(shipment.id)}
                    onDismiss={this.props.dismiss}
                    setInitialFocus={true}
                  >
                    <Mutation mutation={UPDATE_SHIPMENT_STATUS}>
                      {(mutate, { data }) => (
                        <Box m={2} style={{ width: "150px" }}>
                          <Dropdown
                            selectedKey={
                              status &&
                              status.loadingStatus &&
                              status.loadingStatus.key
                                ? status.loadingStatus.key
                                : undefined
                            }
                            onChanged={value => {
                              mutate({
                                variables: {
                                  id: id,
                                  status: JSON.stringify({
                                    ...status,
                                    loadingStatus: value
                                  })
                                }
                              });
                            }}
                            placeHolder="Shipment status"
                            options={[
                              {
                                key: "1",
                                text: "Not loading",
                                labelColor: "#d61717"
                              },
                              {
                                key: "2",
                                text: "Loading",
                                labelColor: "#46992f"
                              },
                              { key: "3", text: "Full", labelColor: "#3a3a37" },
                              { key: "4", text: "Final", labelColor: "#3a3a37" }
                            ]}
                          />
                          <Box mt={1}>
                            <Checkbox
                              label="CMR printed"
                              checked={
                                status && status.cmr ? status.cmr : false
                              }
                              onChange={(ev, isChecked) => {
                                mutate({
                                  variables: {
                                    id: shipment.id,
                                    status: JSON.stringify({
                                      ...status,
                                      cmr: isChecked
                                    })
                                  }
                                });
                              }}
                            />
                          </Box>
                          <Box mt={1}>
                            <Checkbox
                              label="Manifest"
                              checked={
                                status && status.manifest
                                  ? status.manifest
                                  : false
                              }
                              onChange={(ev, isChecked) => {
                                mutate({
                                  variables: {
                                    id: shipment.id,
                                    status: JSON.stringify({
                                      ...status,
                                      manifest: isChecked
                                    })
                                  }
                                });
                              }}
                            />
                          </Box>
                          <Box mt={1}>
                            <Checkbox
                              label="Stickers"
                              checked={
                                status && status.stickers
                                  ? status.stickers
                                  : false
                              }
                              onChange={(ev, isChecked) => {
                                mutate({
                                  variables: {
                                    id: shipment.id,
                                    status: JSON.stringify({
                                      ...status,
                                      stickers: isChecked
                                    })
                                  }
                                });
                              }}
                            />
                          </Box>
                        </Box>
                      )}
                    </Mutation>
                  </Callout>
                </div>
              );
            }}
          </Query>
        )}
      </div>
    );
  }
}

const GET_SHIPMENT_STATUS = gql`
  query shipmentById($id: Int!) {
    shipmentById(id: $id) {
      id
      status
    }
  }
`;

const UPDATE_SHIPMENT_STATUS = gql`
  mutation($id: Int!, $status: JSON) {
    updateShipmentById(input: { id: $id, shipmentPatch: { status: $status } }) {
      shipment {
        id
        status
      }
    }
  }
`;

const mapStateToProps = state => {
  return {
    visible: state.ui.shipmentStatus,
    shipment: state.selected.shipment
  };
};

export default connect(mapStateToProps, {
  dismiss: dismissShipmentStatus
})(ShipmentStatusCallout);



// WEBPACK FOOTER //
// ./src/common/Forms/_ShipmentStatusCallout.js